<template>
	<form @submit.prevent="">
		<div class="form-row">
			<div class="col-12 col-md-12">
				<label for="title">عنوان پوشه</label>
				<input type="text" placeholder="عنوان پوشه" class="widget-input input-no-bg input-lg input-set-border  w-100" v-model="newCategory">
			</div>
		</div>

		<div class="form-row text-center mt-4">
			<div class="col-12">
				<a href="" @click.prevent="saveCategory()" :class="'min-w150 tgju-btn tgju-btn-lg tgju-btn-primary ' + (addEditLoading ? 'loading-active inline-flex' : '')">
					<i class="uil uil-folder-plus"></i>
					<span class="span-title">ایجاد پوشه</span>
				</a>
			</div> 
		</div>
	</form>
</template>

<style lang="scss" scoped>
	.cancel-edit-btn {
		text-align: center;
		margin-top: 5px;
		margin-bottom: 15px;
		cursor: pointer;
		color: #1d1c1c;
	}
</style>

<script>
	export default {
		name: 'NoteCategoriesListModal',
		props: ['data'],
		components: {},
		data: function () {
			return {
				newCategory: '',
				editMode: false,
				editId: null,
				addEditLoading: false,
			}
		},

		mounted() {
			
		},

		methods: {
			goEditCategory(id, title) {
				this.editMode = true;
				this.editId = id;
				this.newCategory = title;
			},

			cancelEditCategory() {
				this.editMode = false;
				this.editId = null;
				this.newCategory = '';
			},

			saveCategory() {
				if(this.addEditLoading == false){
					this.addCategory();
				}
			},

			addCategory() {
				if ( !this.newCategory ) return;

				let api_data = {
					title: this.newCategory,
					extension: this.data.widget.type,
				};
				this.addEditLoading = true;

				this.$helpers.makeRequest('POST', '/category/store', api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						let category = api_response.data.response.category;

						this.$parent.emitData('addCategory', {category: this.$helpers.unbindObject(category)});
						this.newCategory = '';
						
						this.$parent.closeModal();
						this.$swal.fire({
							icon:"success",
							title:"پوشه با موفقیت ایجاد شد",
							showConfirmButton:!1,
							timer:2000
						});
						this.addEditLoading = false;
					}else{
						this.$swal.fire({
							icon:"error",
							title:"مشکلی در ایجاد پوشه رخ داده است",
							showConfirmButton:!1,
							timer:2000
						});
						this.addEditLoading = false;
					}
				});
			},
		},
	}
</script>